package navigation.home.settings

import androidx.compose.runtime.*
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.link.NavLinkState
import navigation.settings.SettingsScreenModel
import navigation.utils.NavLinkScreen
import ui.settings.SettingsScreen

data object SettingsScreenNav : NavLinkScreen {
    override val defaultTitle: String = "Settings"

    override var navLinkState: NavLinkState by mutableStateOf(
        NavLinkState(
            title = defaultTitle,
            iconRes = EsIcons.Settings,
        ),
    )

    @Composable
    override fun Content() {
        val settingsScreenModel = koinScreenModel<SettingsScreenModel>()
        val settingsState by settingsScreenModel.state.collectAsState()

        SettingsScreen(
            state = settingsState,
            onRefresh = { refresh ->
                navLinkState = navLinkState.copy(
                    onRefresh = refresh,
                )
            },
        )
    }
}